export const messageDialogLoadingState = {
  idle: 1,
  inProgress: 2,
  done: 3,
  refresh: 4,
};

export const longPollingRefreshRateMs = 10000;
